import { Expose } from 'class-transformer';

export class GetCancellationPolicyOptionDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'policy_id' })
  policyId: number;
  @Expose({ name: 'amount' })
  amount: number;
  @Expose({ name: 'hours' })
  hours: number;
  @Expose({ name: 'fine' })
  fine: number;
}
